import { useState, useEffect } from 'react';
import { useUserRole } from './useUserRole';
import { storage } from '../utils/storage';

const STORAGE_KEY = 'comanda-preferred-view';
const VALID_MODES = ['kitchen', 'bar', 'waiter'];

export const useViewMode = () => {
  const { role, loading, canToggleViews, defaultView } = useUserRole();
  const [viewMode, setViewModeState] = useState(null);

  useEffect(() => {
    if (loading || !role) return;

    if (canToggleViews()) {
      const saved = storage.get(STORAGE_KEY);
      if (VALID_MODES.includes(saved)) {
        setViewModeState(saved);
      } else {
        setViewModeState(defaultView());
      }
    } else {
      setViewModeState(defaultView());
    }
  }, [role, loading, canToggleViews, defaultView]);

  const setViewMode = (mode) => {
    if (!canToggleViews()) return;
    if (!VALID_MODES.includes(mode)) return;
    setViewModeState(mode);
    storage.set(STORAGE_KEY, mode);
  };

  return {
    viewMode,
    isKitchen: viewMode === 'kitchen',
    isBar: viewMode === 'bar',
    isWaiter: viewMode === 'waiter',
    canToggle: canToggleViews(),
    setViewMode,
    loading: loading || viewMode === null
  };
};
